import React from "react";
import { Card, Input, InputNumber, Select, Switch, Space, Typography } from "antd";
import { PAYMENT_CURRENCY_OPTIONS } from "../operationRequestConstants.js";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{
 *   paymentRequired: boolean,
 *   onPaymentToggle: (v: boolean) => void,
 *   paymentDraft: Record<string, unknown>,
 *   setPaymentDraft: (fn: (p: any) => any) => void,
 * }} props
 */
export default function OperationRequestDynamicFields({
  paymentRequired,
  onPaymentToggle,
  paymentDraft,
  setPaymentDraft,
}) {
  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
          padding: "14px 16px",
          background: "#f8fafc",
          borderRadius: 14,
          border: "1px solid rgba(15,23,42,0.06)",
        }}
      >
        <Text strong>נדרש תשלום מהלקוח?</Text>
        <Switch checked={paymentRequired} onChange={onPaymentToggle} />
      </div>

      {paymentRequired ? (
        <Card size="small" title="תשלום (טיוטה)" style={{ borderRadius: 14 }}>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <div>
              <Text type="secondary">סכום</Text>
              <InputNumber
                style={{ width: "100%", marginTop: 6 }}
                min={0}
                size="large"
                value={paymentDraft.amount}
                onChange={(v) =>
                  setPaymentDraft((p) => ({
                    ...p,
                    amount: v == null || v === "" ? null : Number(v),
                  }))
                }
              />
            </div>
            <div>
              <Text type="secondary">מטבע</Text>
              <Select
                style={{ width: "100%", marginTop: 6 }}
                size="large"
                value={paymentDraft.currency}
                onChange={(v) =>
                  setPaymentDraft((p) => ({
                    ...p,
                    currency: v || "ILS",
                  }))
                }
                options={PAYMENT_CURRENCY_OPTIONS}
              />
            </div>
            <div>
              <Text type="secondary">תיאור לתשלום</Text>
              <Input
                style={{ marginTop: 6 }}
                size="large"
                value={paymentDraft.description}
                onChange={(e) =>
                  setPaymentDraft((p) => ({ ...p, description: e.target.value }))
                }
                placeholder="למשל: תוספת מזוודה, שינוי תאריך — תשלום הפרש"
              />
            </div>
          </Space>
        </Card>
      ) : null}
    </Space>
  );
}
